import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/login/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/home",
    name: "home",
    redirect: "/home/statistics",
    component: () => import("@/views/home/index.vue"),
    children: [
      {
        path: "statistics",
        name: "statistics-management",
        component: () => import("@/views/home/views/statistics/index.vue"),
      },
      {
        path: "list/pending",
        name: "pending-list",
        component: () => import("@/views/home/views/list/pending.vue"),
      },
      {
        path: "list/handled",
        name: "handled-list",
        component: () => import("@/views/home/views/list/handled.vue"),
      },
      {
        path: "questionDetail",
        name: "question-detail",
        component: () => import("@/views/home/views/questionDetail/index.vue"),
      },
      {
        path: "user",
        name: "user-management",
        component: () => import("@/views/home/views/user/index.vue"),
        meta: {
          permissions: ["USER_MANAGE"],
        },
      },
      {
        path: "questionType",
        name: "question-type-management",
        component: () => import("@/views/home/views/questionType/index.vue"),
      },
      {
        path: "department",
        name: "department-management",
        component: () => import("@/views/home/views/department/index.vue"),
        meta: {
          permissions: ["ORG_MANAGE"],
        },
      },
      {
        path: "role",
        name: "role-management",
        component: () => import("@/views/home/views/role/index.vue"),
        meta: {
          permissions: ["ROLE_MANAGE"],
        },
      },
      {
        path: "no-permission",
        name: "no-permission",
        component: () => import("@/views/home/views/noPermission/index.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

router.onError((err) => {
  debugger;
  console.log("router-error", err);
});

export default router;
